import React, {PropTypes} from 'react';
import ShowError from '../../components/error/show_error';
import validate from '../../util/validate';
import {join} from '../../util/common';
import PaymentComponent from '../../payment/payment';
import {Link, browserHistory} from 'react-router';
import browsePackagesAction from '../browser_packages_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {commonFunctions} from '../browser_common';

class MakeOfferPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipmentId : ""
    }
  }
  componentDidMount(){
    if(validate.isEmpty(this.props.browsePackages.offerData))
        browserHistory.push('/browse-shipments/list');
    let shipmentId = commonFunctions.getShipmentId(this.props.location);
    this.setState({
      shipmentId
    })
    this.getDiscountDetails()
  }
  getDiscountDetails = () =>{
    let params={} ;
    const self = this;
    params.shipmentCost = this.props.shipment.shipmentDetails.shipmentCost ? this.props.shipment.shipmentDetails.shipmentCost : 20;
    params.userType = 2 //make an offer
    this.props.browsePackagesAction.getDefaultDiscount(params).then((data) => {
      self.formatShipmentDiscountDetails(data);
    }, (errorRes) => {
        this.setState({error: errorRes.error});
    })
  }
  formatShipmentDiscountDetails = (discount) =>{
    let shipment = Object.assign({}, this.props.shipment.shipmentDetails)
    shipment.awbFee = discount.awbFee;
    if(!discount.isOfferExists)
    {
        shipment.discount = false
    }else{
      shipment.discount = true;
      if(discount.isPromoCode)
      {
        shipment.promoCode = discount.promoCode;
        shipment.offerValue = discount.offerValue;
      }else{
        shipment.promoCode = "Referral";
        shipment.percentageDiscount = discount.percentageDiscount;
      }
    }
    this.setState({
      shipment
    })
  }
  render() {
    const {offerData} = this.props.browsePackages
    return (
      <div className ="make-offer-payment-wrap">
        <PaymentComponent
          paymentFor = {3}
          shipmentId ={this.state.shipmentId}
          shipmentWidgetDetails = {this.state.shipment} />
      </div>
    )
  }
}

MakeOfferPayment = connect((state) => {
  return {
    authState: state.app.auth,
    browsePackages: state.app.browsePackages,
    shipment: state.app.shipment
  }
}, (dispatch) => {
  return {
    browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
  }
})(MakeOfferPayment);

export default MakeOfferPayment;



// WEBPACK FOOTER //
// app/browse_packages/payment/make_offer_payment.jsx